<template>
  <v-app id="inspire">
    <!-- Navigation drawer - Sidebar -->
    <!-- src="https://dozr8la71aog.cloudfront.net/sys.bet/assets/sidebar.jpg" -->
    <v-navigation-drawer v-model="drawer" app :mini-variant.sync="mini">
      <template v-slot:prepend>
        <v-toolbar>
          <img
            :style="{
              'max-width': $vuetify.breakpoint.smAndDown ? '100px' : '200px',
              'max-height': '48px',
            }"
            class="cursor-pointer mr-1"
            @click="$router.push('/')"
            aspect-ratio="1.0"
            :src="
              $operatorLogoUrl(domain)
            "
            :alt="domain"
          />
          <!-- <v-toolbar-title class="pl-2">{{ client }}</v-toolbar-title> -->
        </v-toolbar>
      </template>

      <Sidebar />

      <v-divider></v-divider>
      <ButtonLanguages class="pa-2" />

      <template v-slot:append>
        <v-divider></v-divider>
        <v-toolbar dense>
          <div class="flex-grow-1"></div>
          <v-btn small icon @click.stop="mini = !mini" class="mr-1">
            <v-icon
              v-text="mini ? 'mdi-chevron-right' : 'mdi-chevron-left'"
            ></v-icon>
          </v-btn>
          <div v-if="mini" class="flex-grow-1"></div>
        </v-toolbar>
      </template>
    </v-navigation-drawer>

    <!-- APP BAR -->
    <v-app-bar app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>

      <!-- SubTitle - Animation -->
      <template v-if="this.$store.state.subTitlePages">
        <v-expand-transition>
          <v-toolbar-title
            v-scroll="subTitleTrue"
            v-show="subNamePage"
            class="ml-1"
          >
            <v-icon>mdi-menu-right</v-icon>
            {{ this.$store.state.subTitlePages }}
          </v-toolbar-title>
        </v-expand-transition>
      </template>

      <div class="flex-grow-1"></div>

      <!-- <v-btn icon small>
          <v-icon>mdi-bell-outline</v-icon>
        </v-btn> -->
      <div class="ml-4">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              @click="refreshCash()"
              v-if="$isCreditOnline()"
              :loading="loading"
              v-on="on"
              small
            >
              <v-icon>mdi-autorenew</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("updateBalance") }} </span>
        </v-tooltip>
      </div>
      <User />
    </v-app-bar>

    <!-- Content -->
    <v-main>
      <ProgressLinear />

      <NavigationTabs />

      <FiltersGlobalWrap />

      <v-container>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Sidebar from "./_components/sidebar";
import User from "@/components/user";
import ProgressLinear from "@/components/feedback/progress-linear.vue";
import ButtonLanguages from "@/components/btn-languages/btn-languages";
import FiltersGlobalWrap from "@/components/backoffice/filters_global/wrap";
import NavigationTabs from "@/components/navigationTabs";
// Agent
export default {
  name: "dashboard",
  components: {
    User,
    Sidebar,
    ButtonLanguages,
    ProgressLinear,
    FiltersGlobalWrap,
    NavigationTabs,
  },
  data() {
    return {
      client: "",
      domain: "",
      drawer: null,
      mini: false,
      subNamePage: false,
      loading: false,
      name: "",
    };
  },
  mounted() {
    this.domain = this.$domain();
    this.client = this.$store.state.operators.operator_name;
    // this.$disconnect();
    this.$store.commit("subTitlePages", "");

    this.refreshBalance();
  },
  computed: {
    inCasinoBets() {
      return this.$route.name === "CasinoBets";
    },
  },
  watch: {
    $route() {
      if (this.$isCreditOnline() && this.$store.state.logged.status) {
        this.refreshBalance();
      }
    },
  },
  methods: {
    refreshBalance() {
      if (this.$isCreditOnline() && this.$store.state.logged.status) {
        this.$axios.get("/player/online/bank/balanceOnline").then((resp) => {
          this.$store.commit("setCash", resp.data.dados.balance);
          this.$store.commit("setBonus", {
            value: resp.data.dados.balance_bonus,
            status: resp.data.dados.balance_bonus_status,
          });
          this.$store.commit("setAvailableBalance", resp.data.dados.available_balance);
          this.$store.commit("setRestrictedBalance", resp.data.dados.restricted_balance);
        });
      }
    },
    subTitleTrue(e) {
      if (e.target.scrollingElement.scrollTop >= 100) {
        this.subNamePage = true;
      } else {
        this.subNamePage = false;
      }
    },

    // Refresh Saldo
    refreshCash() {
      this.loading = true;
      this.$axios
        .get("/player/online/bank/balanceOnline")
        .then((resp) => {
          this.$store.commit("setCash", resp.data.dados.balance);
          this.$store.commit("setBonus", {
            value: resp.data.dados.balance_bonus,
            status: resp.data.dados.balance_bonus_status,
          });
          this.$store.commit("setAvailableBalance", resp.data.dados.available_balance);
          this.$store.commit("setRestrictedBalance", resp.data.dados.restricted_balance);
        })
        // .catch((err) => {
        //   console.log(err.response);
        // })
        .finally(() =>
          setTimeout(() => {
            this.loading = false;
          }, 500)
        );
    },
  },
};
</script>
